export default class {
    _id;
    _receiver;
    _address;
    _area;
    _region;
    _pagesCount;
    _isSent;
    _sentOn;
    _createdOn;
    _creatorUser;
    _senderUser;
    _perform;
    _isCharged;
    _chargedOn;
    _sendStatus;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value
    }

    get receiver() {
        return this._receiver;
    }

    set receiver(value) {
        this._receiver = value
    }

    get address() {
        return this._address;
    }

    set address(value) {
        this._address = value
    }

    get area() {
        return this._area;
    }

    set area(value) {
        this._area = value
    }

    get region() {
        return this._region;
    }

    set region(value) {
        this._region = value
    }

    get pagesCount() {
        return this._pagesCount;
    }

    set pagesCount(value) {
        this._pagesCount = value
    }

    get isSent() {
        return this._isSent;
    }

    set isSent(value) {
        this._isSent = value
    }

    get sentOn() {
        return this._sentOn;
    }

    set sentOn(value) {
        this._sentOn = value
    }

    get createdOn() {
        return this._createdOn;
    }

    set createdOn(value) {
        this._createdOn = value
    }

    get creatorUser() {
        return this._creatorUser;
    }

    set creatorUser(value) {
        this._creatorUser = value
    }

    get senderUser() {
        return this._senderUser;
    }

    set senderUser(value) {
        this._senderUser = value
    }

    get perform() {
        return this._perform
    }

    set perform(value) {
        this._perform = value
    }

    get isCharged() {
        return this._isCharged
    }

    set isCharged(value) {
        this._isCharged = value
    }

    get chargedOn() {
        return this._chargedOn;
    }

    set chargedOn(value) {
        this._chargedOn = value;
    }

    get sendStatus() {
        return this._sendStatus;
    }

    set sendStatus(value) {
        this._sendStatus = value;
    }
}
